import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import * as opCoService from "../service/OpCo"
import { OperatingCompanyCreate, Body_config_file_to_db_settings_opcos__opco_id__config_validation_rules_post } from "../api/generated"
import useShowError from "./useShowError"
import { QUEUE_DROPDOWN_KEY } from "../constants"

const OPCO = "opco"

export const useCreateOpco = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (team: OperatingCompanyCreate) => {
      return opCoService.createOpco({
        ...team
      })
    },onSuccess() {
      queryClient.invalidateQueries({
        queryKey: ['work_lists'],
      })
    }
  })
}

export const useGetAllOpco = () => {
  return useQuery({
    queryKey: [OPCO],
    queryFn: () => opCoService.getAllOpco(),
    placeholderData: [],
  })
}

export const useUpdateOpco = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({
      id, ...args
    }: {
      id: number
    }) => {
      return opCoService.updateOpco(id, args)
    }, onSuccess() {
    queryClient.invalidateQueries({
      queryKey: ['work_lists'],
    })
    queryClient.invalidateQueries({ queryKey: QUEUE_DROPDOWN_KEY });
  }
  })
}

export const downloadOpcoTemplate = () => {
  return useMutation({
    mutationFn: () => opCoService.downloadOpcoTemplateGet(),
  })
}

export const uploadOpcoTemplate = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (file: Blob) => {
      return opCoService.uploadOpcoPost({
        file
      })
    },
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: [OPCO] });
      queryClient.refetchQueries({queryKey:["teams"]})
      queryClient.refetchQueries({queryKey:["validation_config_rules"]})
      queryClient.refetchQueries({queryKey:["validation_rules"]})
    },
  })
}

export const usePostValidationConfigValues = () => {
  const queryClient = useQueryClient()
  const showError = useShowError()

  return useMutation({
      mutationFn: ({ id, payload }: { id: number; payload:any }) =>
        opCoService.postConfigValRule(id, undefined, undefined, undefined, undefined, payload),
      onSuccess() {
        queryClient.invalidateQueries({queryKey: ["validation_config_rules"]});
      },
      onError(error) {
        showError(`Something went wrong, please try again: ${error.message}`)
      },
    })
}